module.exports = __webpack_public_path__ + "assets/a9692661c3723ee16cb888d55ea2fa80.png";